import { makeStyles } from '@material-ui/core'

const styles = (errors) =>
  makeStyles((theme) => ({
    container: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      gap: theme.spacing(2),
      backgroundColor: theme.palette.background.default,
      padding: theme.spacing(2),
      [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
        alignItems: 'flex-end',
      },
    },

    buttonColor: {
      backgroundColor: errors?.email && theme.palette.error.main,
      '&:hover': {
        backgroundColor: errors?.email && theme.palette.error.dark,
      },
    },
    button: {
      marginLeft: 20,
    },
  }))

export default styles
